<template>
  <div>
    <div
      class="info-item"
      :key="delivery_type + '_delivery'"
      v-for="delivery_type in existing_delivery_types"
    >
      <div class="table-header">
        訂購明細 - {{ delivery_types[delivery_type] }}
      </div>
      <DataTable
        :ref="'datatable_' + delivery_type"
        :value="
          $page.props.order.items[delivery_type].filter(
            (product) => product.type != 'add-on'
          )
        "
        :expandedRows.sync="expended_products_by_type[delivery_type]"
        responsiveLayout="scroll"
      >
        <Column headerClass="w-11">
          <template #body="slotProps">
            <div v-if="slotProps.data.type == 'add-on'">加購</div>
          </template>
        </Column>

        <Column :ref="delivery_type + '_product_column'" header="商品">
          <template #body="slotProps">
            <div class="flex justify-start items-center gap-x-4 max-w-full">
              <!-- @click="goToProductPage(slotProps.data.slug)" -->
              <img
                v-if="
                  Array.isArray(slotProps.data.images) &&
                  slotProps.data.images.length > 0
                "
                class="object-cover aspect-square product-image"
                :src="
                  '/storage/product-images/' +
                  slotProps.data.images[0] +
                  '/100.jpg'
                "
              />
              <img
                v-else
                class="object-cover aspect-square product-image"
                src="//dummyimage.com/100/ccc/666?text=%E5%90%83%E8%B2%A8%E5%AE%B6"
              />
              <div class="">
                {{ slotProps.data.name }}
              </div>
            </div>
          </template>
        </Column>

        <Column headerClass="w-40" header="價格">
          <template #body="slotProps">
            <div class="flex flex-col justify-start items-start gap-y-1">
              <div>
                {{ slotProps.data.unit_price | commaFormat | priceFormat }}
              </div>
              <div>CV: {{ slotProps.data.unit_cv | commaFormat }}</div>
            </div>
          </template>
        </Column>

        <Column headerClass="w-20" header="數量">
          <template #body="slotProps">
            <div class="flex flex-col justify-between items-center">
              <div>
                {{ slotProps.data.quantity }}
              </div>
            </div>
          </template>
        </Column>

        <Column headerClass="w-40" header="總計">
          <template #body="slotProps">
            <div class="flex flex-col justify-start items-start gap-y-1">
              <div>
                {{ slotProps.data.total_price | commaFormat | priceFormat }}
              </div>
              <div>CV: {{ slotProps.data.total_cv | commaFormat }}</div>
            </div>
          </template>
        </Column>

        <template #footer>
          <div
            class="mt-0 mb-3"
            v-if="hasAddOn($page.props.order.items[delivery_type])"
          >
            <DataTable
              responsiveLayout="scroll"
              :value="
                $page.props.order.items[delivery_type].filter(
                  (product) => product.type == 'add-on'
                )
              "
            >
              <Column headerClass="w-11"
                ><template #body="slotProps">
                  <div v-if="slotProps.data.type == 'add-on'">加購</div>
                </template></Column
              >
              <Column
                ><template #body="slotProps">
                  <div
                    class="flex justify-start items-center gap-x-4"
                    @click="goToProductPage(slotProps.data.slug)"
                  >
                    <img src="//dummyimage.com/100" class="product-image" />
                    <div class="">
                      {{ slotProps.data.id }} {{ slotProps.data.name }}
                    </div>
                  </div>
                </template></Column
              >
              <Column headerClass="w-40"
                ><template #body="slotProps">
                  <div class="flex flex-col justify-start items-start gap-y-1">
                    <div>
                      {{
                        slotProps.data.unit_price | commaFormat | priceFormat
                      }}
                    </div>
                    <div>CV: {{ slotProps.data.unit_cv | commaFormat }}</div>
                  </div>
                </template></Column
              >
              <Column headerClass="w-20"
                ><template #body="slotProps">
                  <div class="flex flex-col justify-between items-center">
                    <div>
                      {{ slotProps.data.quantity }}
                    </div>
                  </div>
                </template></Column
              >
              <Column headerClass="w-40"
                ><template #body="slotProps">
                  <div class="flex flex-col justify-start items-start gap-y-1">
                    <div>
                      {{
                        slotProps.data.total_price | commaFormat | priceFormat
                      }}
                    </div>
                    <div>CV: {{ slotProps.data.total_cv | commaFormat }}</div>
                  </div>
                </template></Column
              >
            </DataTable>
          </div>

          共有
          {{
            $page.props.order.items[delivery_type]
              ? $page.props.order.items[delivery_type].length
              : 0
          }}
          個商品。
          {{ $page.props.order.price_per_type[delivery_type] }} /
          {{ $page.props.order.cv_per_type[delivery_type] }} /
          {{ $page.props.order.shipping_per_type[delivery_type] }}
        </template>
      </DataTable>
    </div>
  </div>
</template>

<script>
import DataTable from "primevue/datatable";
import Column from "primevue/column";

export default {
  components: {
    DataTable,
    Column,
  },
  filters: {
    priceFormat: function (value) {
      return "$" + value;
    },
    commaFormat: function (value) {
      return value
        .toString()
        .replace(
          /^(-?\d+?)((?:\d{3})+)(?=\.\d+$|$)/,
          function (all, pre, groupOf3Digital) {
            return pre + groupOf3Digital.replace(/\d{3}/g, ",$&");
          }
        );
    },
  },
  computed: {
    existing_delivery_types() {
      return _.keys(this.$page.props.order.items);
    },
  },
  data() {
    return {
      delivery_types: {
        normal: "常溫商品",
        refrigerated: "冷藏商品",
        frozen: "冷凍商品",
      },
      expended_products_by_type: { normal: [], refrigerated: [], frozen: [] },
    };
  },
  methods: {
    hasAddOn(products) {
      return (
        _.findIndex(products, {
          type: "add-on",
        }) >= 0
      );
    },
  },
};
</script>

<style lang="postcss">
/*  */
</style>